export function capFirst(s?: string) {
	if (!s) return s;
	const firstChar = s[0].toUpperCase();
	s = s.slice(1, s.length);
	s = firstChar + s;
	return s;
}
